// import { Map } from './Map';
import { InteracitveMap } from './InteractiveMap';
import { Box, Card, CardContent, Grid, Typography } from '@mui/material';
import { CardInfo, RegionInfo } from './IspDashboard';
import { useEffect, useState } from 'react';
import { useApi } from '@bumble/app/hooks/use-api';
import { useQuery } from '@tanstack/react-query';
import { HttpResponse } from '@bumble/app/__generated__/http-client';
import Select from 'react-select';

interface CPEDashboardInfo {
  Global: object;
  Regions: object;
  Devices: object[];
};

export const MapDashboard = () => {
  const api = useApi();
  const [dataCards, setDataCards] = useState<CardInfo[] | null>(null);
  // const [regions, setRegions] = useState<RegionInfo[] | null>(null);
  // const [totalCount, setTotalCount] = useState(0);
  const [devices, setDevices] = useState<any[]>([]);
  const [entities, setEntities] = useState<any[]>([{label: 'None', value: 'none'}]);
  const [entity, setEntity] = useState<string>('none');
  const primaryColors = ['#77C075', '#69AAD8', '#D69847', '#BF5644', '#6F4E8C', '#4AA3A2', '#C46B9E'];
  const secondaryColors = ['#6AA968', '#5D95C0', '#BE873F', '#A94C3D', '#5C3D7A', '#3F8F8E', '#AC5C8A'];

  const { data: cpeData } = useQuery(
    ['prepareIspDashboardData', entity],
    api.dashboardGetSummaryApiV1DashboardGetSummaryGet.bind(
      null,
      entity === 'none' ? {} : { entity_name: entity }
    ),
    { enabled: true, cacheTime: 0, initialData: undefined },
  );

  useEffect(() => {
    if (cpeData != undefined && cpeData != null) {
      let arr: CardInfo[] = [], darr: RegionInfo[] = [], index = 0;
      let { data: { Global, Regions, Devices } } = cpeData as HttpResponse<CPEDashboardInfo>;
      let cnt = 0;
      for (let [key, value] of Object.entries(Global)) {
        arr.push({
          name: key,
          count: value,
          // Cycle the palette so more categories than colors (e.g. 7 boxes
          // against a 5-colour palette) still get a filled card instead of an
          // undefined background that renders white-on-white and looks empty.
          primaryColor: primaryColors[index % primaryColors.length],
          secondaryColor: secondaryColors[index % secondaryColors.length]
        });
        cnt += value;
        index++;
      }
      setDataCards(arr);
      for (let [key, {latitude, longitude, count }] of Object.entries(Regions)) {
        if (latitude == null || longitude == null || key == 'unknown') continue;
        darr.push({
          name: key,
          latitude: parseFloat(latitude),
          longitude: parseFloat(longitude),
          data: count
        });
      }
      // setRegions(darr);
      // setTotalCount(cnt);
      setDevices(Devices);
    }
  }, [cpeData]);

  const { isLoading: isLoading2, data: entityNames } = useQuery(
    ['prepareEntityNames'],
    api.getEntityNamesApiV1GetEntityNamesGet.bind(null, {}),
    { enabled: true, cacheTime: 0, initialData: undefined },
  );

  useEffect(() => {
    const entity_data = entityNames?.data;
    let actualEntities = [{label: 'None', value: 'none'}];
    if (entity_data && entity_data.length) {
      actualEntities = actualEntities.concat(entity_data.map((e: string) => ({
        label: e,
        value: e,
      })))
    }
    setEntities(actualEntities);
  }, [entityNames]);

  const changeEntity = (val: any) => {
    setEntity(val.value);
  };

  return (
    <Box sx={{ mb: 0, py: 5 }}>
      <Box sx={{ mb: 5 }}>
        <Select options={entities} defaultValue={entities[0]} onChange={changeEntity} styles={{
          control: (baseStyles) => ({
            ...baseStyles,
            width: '300px',
          }),
          menu: (baseStyles) => ({
            ...baseStyles,
            width: '300px',
          }),
        }} />
      </Box>
      {/* {(isLoading || isLoading2) ? <Loading /> : <> */}
      <Grid container spacing={5} >
        {dataCards && dataCards.map(({ name, count, primaryColor }: CardInfo, i) => (
          <Grid item key={i} >
            <Card elevation={0} sx={{
              backgroundColor: `${primaryColor}`,
              width: 150,
              height: 150,
              display: 'flex',
              flexDirection: 'row'
            }}>
              <CardContent sx={{
                p: 0,
                m: 0,
                ":last-child": {
                  pb: 0
                }
              }}>
                <Grid container>
                  <Grid item xs={12} sx={{ p: 5, pb: 4, pt: 13 }}>
                    <Typography variant="h1" gutterBottom sx={{ fontWeight: 700, mb: 0 }} color="white">
                      {count}
                    </Typography>
                    <Typography variant="subtitle2" color="white">{name}</Typography>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
      {/* <Map regions={regions} primaryColors={primaryColors} totalCount={totalCount} dataCards={dataCards} /> */}
      {devices && devices.length ? <InteracitveMap devices={devices} /> : <InteracitveMap />}
      {/* </>} */}
    </Box>
  );
}